import responseHandler from "../system/server-response-handler";
import {
  formDataPostRequest,
  formDataPutRequest,
  getRequest,
  postRequest,
} from "../system/server-calls";

const COMMON_URL = "Property";

//Getting all property types
const getAllPropertyTypes = () => {
  return getRequest(`${COMMON_URL}/GetAllPropertyTypes`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const getAllViewTypes = () => {
  return getRequest(`GetViewTypes`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getPropertyTypesByUser = (data) => {
  return postRequest(`${COMMON_URL}/PropertyTypes`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const addPropertyTypeForUser = (data) => {
  return postRequest(`User/add-property-types`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting the fresh of the market property
const getAllFreshProperty = (data) => {
  return postRequest(`${COMMON_URL}/FreshList`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting the recommended property
const getAllRecommendedProperty = (data) => {
  return postRequest(`${COMMON_URL}/RecommendedList`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting the favourites property
const getAllFavouritesProperty = (data) => {
  return postRequest(`${COMMON_URL}/FavouriteList`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting the favourites property
const getAllFavouritesPropertyForUser = () => {
  return getRequest(`${COMMON_URL}/GetFavouriteProperties`,).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting all properties
const getAllProperties = (data) => {
  return postRequest(`${COMMON_URL}/GetPaginatedPropertyList`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting the property detail
const getPropertyDetailById = (propertyId) => {
  return getRequest(`${COMMON_URL}/GetPropertyDetail/${propertyId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Property mark as favourite
const addToFavouriteProperty = (body) => {
  return postRequest(`${COMMON_URL}/AddToFavourite`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Property remove from favourite
const removeFromFavouriteProperty = (body) => {
  return postRequest(`${COMMON_URL}/RemoveFromFavourite`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Property mark as not interested
const addToNotInterestedProperty = (id) => {
  return postRequest(`${COMMON_URL}/AddToNotInterested/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Property mark as Interested or not
const removeFromNotInterestedProperty = (id) => {
  return postRequest(`${COMMON_URL}/RemoveFromNotInterested/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const createProperty = (body) => {
  return formDataPostRequest(`${COMMON_URL}/Create`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateProperty = (body) => {
  return formDataPutRequest(`${COMMON_URL}/Update`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getPropertyDetailsForUser = (id) => {
  return getRequest(`${COMMON_URL}/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const makePropertyFavourite = (id) => {
  return postRequest(`${COMMON_URL}/AddToFavourite/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const removePropertyFromFavourite = (id) => {
  return postRequest(`${COMMON_URL}/RemoveFromFavourite/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const propertyService = {
  getAllPropertyTypes,
  getAllViewTypes,
  getAllFreshProperty,
  getPropertyDetailById,
  getPropertyDetailsForUser,
  getAllFavouritesProperty,
  getAllRecommendedProperty,
  addToFavouriteProperty,
  removeFromFavouriteProperty,
  addToNotInterestedProperty,
  removeFromNotInterestedProperty,
  createProperty,
  updateProperty,
  getAllProperties,
  getPropertyTypesByUser,
  makePropertyFavourite,
  removePropertyFromFavourite,
  getAllFavouritesPropertyForUser,
  addPropertyTypeForUser,
};
